import create from 'zustand/vanilla';
import createHook from 'zustand';
import { emptyObject } from '@constants/empty';

export const helperFlagsStore = create((set) => ({
  plannerHelperFlags: emptyObject,
  setIsFirstRun: (isFirstRun, goalUID) => {
    set((state) => ({
      ...state,
      plannerHelperFlags: {
        ...state.plannerHelperFlags,
        [goalUID]: {
          ...state.plannerHelperFlags?.[goalUID],
          isFirstRun
        }
      }
    }));
  },
  setIsInitialSetupComplete: (isInitialSetupComplete, goalUID) => {
    set((state) => ({
      ...state,
      plannerHelperFlags: {
        ...state.plannerHelperFlags,
        [goalUID]: {
          ...state.plannerHelperFlags?.[goalUID],
          isInitialSetupComplete
        }
      }
    }));
  },
  setIsFinalSetupComplete: (isFinalSetupComplete, goalUID) => {
    set((state) => ({
      ...state,
      plannerHelperFlags: {
        ...state.plannerHelperFlags,
        [goalUID]: {
          ...state.plannerHelperFlags?.[goalUID],
          isFinalSetupComplete
        }
      }
    }));
  },
  setIsEveryTimeTasksSetupComplete: (
    isEveryTimeTasksSetupComplete,
    goalUID
  ) => {
    set((state) => ({
      ...state,
      plannerHelperFlags: {
        ...state.plannerHelperFlags,
        [goalUID]: {
          ...state.plannerHelperFlags?.[goalUID],
          isEveryTimeTasksSetupComplete
        }
      }
    }));
  }
}));

export const helperFlagsStoreV2 = create((set) => ({
  plannerHelperFlags: emptyObject,
  setIsFinalSetupComplete: (isFinalSetupComplete) => {
    set((state) => ({
      ...state,
      plannerHelperFlags: {
        ...state.plannerHelperFlags,
        isFinalSetupComplete
      }
    }));
  }
}));

const useHelperFlagsStore = createHook(helperFlagsStore);
export const useHelperFlagsStoreV2 = createHook(helperFlagsStoreV2);

export default useHelperFlagsStore;
